// src/components/MiniTimerBar.js
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTimer } from "../contexts/TimerContext";
import { useLang } from "../contexts/LanguageContext";
import locales from "../utils/locales";

export default function MiniTimerBar() {
  const { timerState, stopTimer, cancelTimer } = useTimer();
  const { lang } = useLang();
  const t = locales[lang] || {};
  const location = useLocation();
  const navigate = useNavigate();

  // ไม่โชว์ถ้า timer ไม่รัน หรืออยู่หน้าจับเวลา
  if (
    !timerState.running ||
    location.pathname === "/add" ||
    location.pathname === "/add-calendar"
  )
    return null;

  // Format mm:ss
  const formatTime = s => {
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return `${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
  };

  // เมื่อ finish ให้ stopTimer แล้ว redirect ไปหน้า AddActivity
  const handleFinish = () => {
    stopTimer();
    // ส่ง activity กลับไปหน้า /add ด้วย query params (optionally, หรือตั้งใน Context)
    navigate("/add", {
      state: {
        fromTimer: true,
        activityName: timerState.activityName,
        activityCategory: timerState.activityCategory,
        activityDate: timerState.activityDate,
        durationSeconds: timerState.seconds,
        startedAt: timerState.startedAt,
        finishedAt: new Date().toISOString(),
      }
    });
  };

  return (
    <div className="fixed bottom-16 left-1/2 -translate-x-1/2 z-50 bg-indigo-700 text-white flex items-center justify-between px-5 py-3 shadow-2xl rounded-full max-w-md w-[94vw] transition-all animate-fade-in">
      <div className="flex flex-col">
        <span className="font-semibold text-base truncate max-w-[180px]">
          ⏳ {timerState.activityName || t.timer_running || "Timer running..."}
        </span>
        <span className="text-xs">{formatTime(timerState.seconds)}</span>
      </div>
      <div className="flex gap-2">
        <button
          onClick={handleFinish}
          className="bg-green-500 hover:bg-green-600 px-4 py-1 rounded-lg font-semibold transition"
          aria-label={t.finish || "Finish"}
        >
          {t.finish || "Finish"}
        </button>
        <button
          onClick={cancelTimer}
          className="bg-gray-500 hover:bg-gray-600 px-4 py-1 rounded-lg font-semibold transition"
          aria-label={t.cancel || "Cancel"}
        >
          {t.cancel}
        </button>
      </div>
    </div>
  );
}